import { Component, OnInit, forwardRef, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { DemoozDateToStringPipe } from '@demooz/pipes';
import { DemoozButtonComponent } from '@demooz/components';
import { DataService } from '@app/services';
import { Question } from '@app/models';

@Component({
    selector: 'app-questions-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonIcon, TranslatePipe, DemoozDateToStringPipe, forwardRef(() => DemoozButtonComponent)
    ]
})
export class QuestionsItemComponent  implements OnInit {
      
    @Input({alias : 'question', required : true}) question: Question;
    @Output() onAnswerQuestion = new EventEmitter<any>();
     
    questionAnswered: boolean = false;
    displayQuestionText: boolean = false;
    testerName: string = '';
    dateCreation: Date;
    dateAnswer: Date;
      
    constructor(             
        public dataService: DataService
    ) { }

    ngOnInit() {
        
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['question'] && changes['question'].currentValue){
            this.initQuestion();
        }
    }
    
    initQuestion(){
        this.displayQuestionText = false;
        this.questionAnswered = this.question.status === 'answered' && this.question.responses.length > 0;
        this.testerName = this.question.tester?.firstName+' '+this.question.tester?.lastName.charAt(0)+'.';        
        this.dateCreation = new Date(parseInt(this.question._.created));       
        if(this.questionAnswered){
            if(this.question.responses[0].responseDate){
                this.dateAnswer =  new Date(parseInt(this.question.responses[0].responseDate));
            }
        }
    }
    
    toggleQuestionText() {
        this.displayQuestionText = !this.displayQuestionText;
    }
        
    answerQuestion($event: Event){
        $event.stopPropagation();
        this.onAnswerQuestion.emit(this.question);
    }
}
